const map = {
	"./24hr.svg": 90994,
	"./account.svg": 65315,
	"./add-your-logo.svg": 53991,
	"./addIcon.svg": 21232,
	"./aim.svg": 91321,
	"./alert.svg": 17508,
	"./arrow-down.svg": 77398,
	"./arrow-left.svg": 17309,
	"./arrow-right.svg": 512,
	"./arrow-up.svg": 74221,
	"./basket.svg": 29260,
	"./calculator.svg": 67970,
	"./card.svg": 53380,
	"./check-circle.svg": 49567,
	"./check-green.svg": 64576,
	"./check.svg": 44466,
	"./checkbox-active.svg": 73340,
	"./checkbox-empty.svg": 63661,
	"./clock.svg": 99304,
	"./close.svg": 78849,
	"./copy.svg": 46473,
	"./delivery.svg": 71378,
	"./edit.svg": 73862,
	"./email.svg": 42334,
	"./embroidery.svg": 1062,
	"./empty-star.svg": 93862,
	"./express.svg": 3670,
	"./facebook.svg": 57654,
	"./faq.svg": 11282,
	"./filled-star.svg": 39067,
	"./filter-black.svg": 76346,
	"./filter.svg": 39568,
	"./flash.svg": 50516,
	"./flash2.svg": 89518,
	"./instagram.svg": 54162,
	"./lightning-bolt.svg": 63540,
	"./logo.svg": 7875,
	"./menu.svg": 67331,
	"./new.svg": 21856,
	"./phone.svg": 89090,
	"./print.svg": 77835,
	"./processing.svg": 72519,
	"./promise.svg": 65141,
	"./remove.svg": 56142,
	"./save-cart.svg": 48352,
	"./search.svg": 53842,
	"./size.svg": 74981,
	"./star-half.svg": 36576,
	"./star.svg": 4258,
	"./text.svg": 90719,
	"./twitter.svg": 14499,
	"./uk-flag.svg": 51193,
	"./youtube.svg": 90665,
	"./zoom.svg": 14607
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33362;